import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import Translate from 'translate';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';

import AuthService from 'services/AuthService';
import SimplePanel from 'components/HTMLElements/Panel/Simple/';
import ChangeStatusModal from 'routes/app/components/Agent/ChangeStatusModal/';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import MessageList from './MessageList';
import checkbox from "assets/images/checkbox.svg";
import { Checkbox } from "components/FormElements";
import ChannelService from "../../../../../services/ChannelService";
import DeleteModal from "components/HTMLElements/DeleteModal";

class ChatDetail extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      changeStatusModalOpened: false,
      deleteModalOpened: false,
    };

    this.userIsSupervisor = AuthService.getUserRole().isSupervisor;
    this.toggleChangeStatusModal = this.toggleChangeStatusModal.bind( this );
    this.toggleDeleteModal = this.toggleDeleteModal.bind( this );
    this.removeCategory = this.removeCategory.bind( this );
  }

  toggleChangeStatusModal( status = '' ) {
    this.statusToUpdate = status;
    this.setState( { changeStatusModalOpened: !this.state.changeStatusModalOpened } )
  }

  toggleDeleteModal( categoryId ) {
    this.categoryToDelete = categoryId;

    if( this.props.confirmDelete ) return this.setState( { deleteModalOpened: !this.state.deleteModalOpened } );
    this.removeCategory()
  }

  removeCategory() {
    this.props.toggleLoading( true );

    ChannelService.deleteChannelCategory( this.props.data.id, this.categoryToDelete )
      .then( ( response ) => {
        if( response.errors ) {
          this.props.toggleLoading( false );
          return this.props.toggleAlertError( response.errors );
        }
        this.props.onReloadData();
        if( this.props.confirmDelete ) this.setState( { deleteModalOpened: false } )
      } );
  }

  render() {
    const {
      data, options, onAssign, onReloadData, onReloadClosedChannel, onReloadChannel,
      messages, intl, hasMore, onLoadMore, websocketStatus, userIsOnline, confirmDelete
    } = this.props;

    return (
      <div>
        <SimplePanel className="m-0 no-shadow border-y border-gray-1" contentClassName="pt-2 pb-0 px-0">
          <div className="row align-items-center px-3 pb-1">
            <div className="col-md">
              {_.get( data, 'openAt' ) &&
              <p className="m-0 color-gray-2">
                <span className="font-weight-medium"><Translate id="open"/>: </span>
                {moment( _.get( data, 'openAt' ) ).format( 'DD/MM/YYYY h:mm A' )}
              </p>
              }
            </div>

            <div className="col-md-auto d-flex align-items-center">
              <div>
                {_.get( data, 'chatPublic' )    &&
                  <span key={1} className="badge badge-pill badge-primary font-weight-normal text-small mx-1">
                  {intl.formatMessage( { id: "Private" } ) }
                  </span>
                }

              </div>
            </div>
          </div>
          <div className="row px-3">
            <div className="col-md">
              {_.map( data.categories, ( category, index ) =>
                <span key={index}
                      className="badge badge-pill badge-secondary bg-gray-3 font-weight-normal text-small mx-1">
                        <span className="d-flex align-items-center">
                          {category.category}
                          {this.userIsSupervisor && data.status !== 'closed' &&
                          <i className="icon-close pointer ml-2"
                             style={{ fontSize: 8 }}
                             onClick={() => this.toggleDeleteModal( category.id )}/>
                          }
                        </span>
                    </span> )
              }
            </div>
            <div className="col-md-auto">
              {!!data && data.status === 'open' && data.agent ?
                userIsOnline && userIsOnline.channelId === data.id ?
                  <span style={{ color: '#42D358' }} className="mx-3 d-inline-flex align-items-center">
                  <i className="fa fa-circle mr-1" style={{ fontSize: '10px' }}/> <span>online</span>
                </span> :
                  <span style={{ color: '#EF5350' }} className="mx-3 d-inline-flex align-items-center">
                  <i className="fa fa-circle-o mr-1" style={{ fontSize: '10px' }}/> <span>offline</span>
                </span> : null
              }
              {( websocketStatus === 'on' && ( data.status === 'created' || data.status === 'return' || data.status === 'assigned' ) || data.status === 'closed' ) &&
              <i className={classNames( 'fa fa-play p-2 ml-3', {
                'color-purple pointer': websocketStatus === 'on',
                'color-gray-light': websocketStatus !== 'on',
              } )}
                 style={{ fontSize: 18 }}
                 onClick={() => websocketStatus !== 'on' ? {} : this.toggleChangeStatusModal( 'open' )}>
              </i>
              }
              {this.userIsSupervisor && data.status === 'open' &&
              <span>
                <i data-tip={intl.formatMessage( { id: "UnassignCase" } )}
                   className="icon-reply pointer color-purple p-2 text-16"
                   onClick={() => this.toggleChangeStatusModal( 'return' )}/>
                <ReactTooltip place="bottom" type="dark" effect="solid"/>
              </span>
              }
              {( data.status === 'open' || data.status === 'in_progress' ) &&
              <span>
                <i className="icon-check pointer color-purple p-2 text-16"
                   data-tip={intl.formatMessage( { id: "ResolveCase" } )}
                   onClick={() => this.toggleChangeStatusModal( 'closed' )}
                />
                <ReactTooltip place="bottom" type="dark" effect="solid"/>
              </span>
              }
              {this.userIsSupervisor && data.status !== 'closed' &&
              <span>
                <i data-tip={intl.formatMessage( { id: "AssignCase" } )}
                   className="icon-add-user pointer color-purple p-2 text-16"
                   onClick={onAssign}>
                </i>
                <ReactTooltip place="bottom" type="dark" effect="solid"/>
              </span>
              }
            </div>
          </div>

          <hr className="mb-0"/>

          <MessageList
            data={messages}
            messagesToSend={[]}
            responses={options.responses}
            hasMore={hasMore}
            isOpened={data.status === 'open'}
            selectedChannelId={data.id}
            //date={messagesReloadedAt}
            onFetchData={() => onLoadMore( data.id )}
          />
        </SimplePanel>

        <ChangeStatusModal channel={data}
                           data={{ status: this.statusToUpdate }}
                           type="chat"
                           tones={options.tones}
                           open={this.state.changeStatusModalOpened}
                           onClose={this.toggleChangeStatusModal}
                           onReloadClosedChannel={onReloadClosedChannel}
                           onReloadData={onReloadData}
                           onReloadChannel={onReloadChannel}
        />


        {confirmDelete &&
        <DeleteModal label={<Translate id="youSureDeleteCategory"/>}
                     onConfirm={this.removeCategory}
                     opened={this.state.deleteModalOpened}
                     onToggle={this.toggleDeleteModal}
        />
        }
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ( {
  confirmDelete: state.user.beforeDelete,
  websocketStatus: state.websocket.status,
  userIsOnline: state.websocket.online,
} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( injectIntl( ChatDetail ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ChatDetail/index.js